function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".previewa,.previewb{fill:#5594ff;}.previewb{stroke:#5594ff;stroke-width:0.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2310.846 -489.417)"
}, /*#__PURE__*/React.createElement("path", {
  className: "previewa",
  d: "M2324.1,490.81a11.357,11.357,0,1,1-11.357,11.357A11.37,11.37,0,0,1,2324.1,490.81m0-1.893a13.25,13.25,0,1,0,13.25,13.25,13.25,13.25,0,0,0-13.25-13.25Z",
  transform: "translate(0 0.5)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1144.443 -2.802)"
}, /*#__PURE__*/React.createElement("path", {
  className: "previewb",
  d: "M3468.991,501.177c3.652,0,5.744,3,5.744,3.957s-2.092,3.956-5.744,3.956-5.744-3-5.744-3.956,2.092-3.957,5.744-3.957m0-.958c-4.169,0-6.7,3.413-6.7,4.914s2.532,4.914,6.7,4.914,6.7-3.413,6.7-4.914-2.531-4.914-6.7-4.914Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "previewb",
  d: "M3489.218,514.05a1.9,1.9,0,1,1-1.9,1.9,1.9,1.9,0,0,1,1.9-1.9m0-.958a2.859,2.859,0,1,0,2.859,2.859,2.862,2.862,0,0,0-2.859-2.859Z",
  transform: "translate(-20.227 -10.818)"
})));

var SvgPreview = function SvgPreview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.5,
    height: 26.5,
    viewBox: "0 0 26.5 26.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview.bccca32c.svg";
export { ForwardRef as ReactComponent };